/* eslint-disable import/first */
import 'lazysizes';
import 'lazysizes/plugins/video-embed/ls.video-embed.min';

import 'babel-polyfill';
import 'whatwg-fetch';
import './components/alert';
import './components/user-tracker';
import './components/forms';
import './components/slider';
import './components/images';
import './components/helpers';
import './components/navigation';
import './components/accordian';
import './components/slide-up';
import './components/scroll-to';
import './components/stepped-form';
import './components/cta-block';
import './components/calculator';
import './components/tables';
import './components/sub-list';
import './components/calculator-modal';
import './components/lander-form';
import './components/popups';
import './components/performance';
import './components/version';



// WEBPACK FOOTER //
// ./app/scripts/app.js